import axios from "axios";
import { config } from "./Constants";
import { getOrCreateDeviceId } from "./deviceId";

// Create an Axios instance
const api = axios.create({
  baseURL: config.url.BASE_URL, // Default base URL for non-auth endpoints
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor: Add Authorization header or any custom headers dynamically
api.interceptors.request.use(
  (requestConfig) => {
    // Route authentication endpoints to AUTH_URL, admin management to direct base URL, others to BASE_URL
    if (
      requestConfig.url &&
      // Route all auth endpoints (including forgot/reset/change password) to AUTH_URL
      (requestConfig.url.startsWith("/auth/") ||
        requestConfig.url.includes("/register") ||
        requestConfig.url.includes("/login"))
    ) {
      // Avoid double "/auth" in final URL when base is AUTH_URL ending with "/auth"
      if (requestConfig.url.startsWith("/auth/")) {
        requestConfig.url = requestConfig.url.replace(/^\/auth\//, "/");
      }
      requestConfig.baseURL = config.url.AUTH_URL;
    } else if (
      requestConfig.url &&
      requestConfig.url.includes("/api/admin/management")
    ) {
      // Admin management endpoints go directly to base URL without /proxy
      requestConfig.baseURL = config.url.BASE_URL.replace("/proxy", "");
    } else {
      requestConfig.baseURL = config.url.BASE_URL;
    }

    // Add authorization header if a token exists (you can retrieve it from localStorage, context, or Redux)
    const token = localStorage.getItem("token");

    if (token) {
      requestConfig.headers["Authorization"] = `Bearer ${token}`;
    }

    // You can add other headers here as needed
    if (requestConfig.method !== "options") {
      requestConfig.headers["X-DEVICE-OS"] = "web";
      requestConfig.headers["X-DEVICE-ID"] = getOrCreateDeviceId();
    }

    // For file uploads, let the browser set multipart/form-data with the
    // correct boundary. The default application/json header would otherwise
    // JSON-stringify the FormData (a File becomes {}), so remove it here.
    if (requestConfig.data instanceof FormData) {
      delete requestConfig.headers["Content-Type"];
    }

    return requestConfig;
  },
  (error) => {
    return Promise.reject(error); // Handle request error globally
  },
);

// Response interceptor: Handle responses and errors globally
api.interceptors.response.use(
  (response) => {
    // You can modify the response data here if needed
    return response;
  },
  (error) => {
    // Handle response errors globally (e.g., log out user on 401)
    if (error.response && error.response.status === 401) {
      // For example, clear token and redirect to login page
      localStorage.removeItem("token");
      // window.location.href = "/";
    }
    return Promise.reject(error); // Pass the error to the catch block in your components
  },
);

export default api;
